// Added by Sejune Oh on 2020-03-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Style
import { customStyles } from '@/components/worklist/TaskDetailView'
import { customStyles as TaskLogDialogStyles } from '@/components/common/v2/Dialog/TaskLogDialog'
import { customStyles as DialogWrapperStyles } from '@/components/common/v2/Dialog/DialogWrapper'
import { customStyles as ButtonStyles } from '@/components/worklist/Button'

type ComponentTypes = 'taskdetail' | 'taskmessagedialog' | 'dialogwrapper' | 'button'

export type TaskDetailStyleTypes = {
  [key in ComponentTypes]: Record<string, any>
}

export const TaskDetailStyles: TaskDetailStyleTypes = {
  taskdetail: customStyles,
  taskmessagedialog: TaskLogDialogStyles,
  dialogwrapper: DialogWrapperStyles,
  button: ButtonStyles
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Wrapper Component
export { default as TaskDetailViewWrapper } from './TaskDetailViewWrapper'
export * from './TaskDetailViewWrapper'
